module.exports = __webpack_public_path__ + "officialStatic/img/soft24.f164213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft24.png
// module id = xsxf
// module chunks = 0